import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { useAuth } from '../auth/AuthProvider';
import { useNavigate } from 'react-router-dom';

export default function NoAccessPage() {
  const { isSuperuser } = useAuth();
  const navigate = useNavigate();
  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 6 }}>
      <Paper elevation={3} sx={{ p: 3, maxWidth: 520, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ mb: 1 }}>Sin acceso asignado</Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Pide a tu administrador que te asigne permisos.
        </Typography>
        {isSuperuser && (
          <Button variant="contained" onClick={() => navigate('/admin/companies')}>Ir a Administración</Button>
        )}
      </Paper>
    </Box>
  );
}

